/* eslint react/jsx-no-bind: 0 */  // --> OFF
import { CloseRounded } from "@mui/icons-material";
import {
	Button,
	Grid,
	IconButton,
	Select,
	TextField,
	MenuItem,
	FormControl,
	InputLabel, CircularProgress,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import moment from "moment/moment";

function DateModal(props) {
	const [event, setEvent] = useState({
		themePlanId: 0,
		lessonDate: '2024-01-01',
		pairNumber: "1"
	});
	
	const [availableLessonDates, setAvailableLessonDates] = useState([]);
	const [availablePairs, setAvailablePairs] = useState([]);
	const [refresh, setRefresh] = useState(false);
	const isAdmin = localStorage.getItem("roles").split(",").find((r) => r === "AttNewAdmin") !== undefined;

	useEffect(() => {
		if (props.event) {
			setEvent(props.event);
			console.log('[DEBUG] Event', props.event);
			
			props.getAvailableDatesMutation({
				data: {
					lessonId: props.event.lessonId
				}
			}).unwrap().then((fulfilled) => {
				setAvailableLessonDates(fulfilled.data)
			});
			
			setAvailablePairs([props.event.pairNumber]);
		}
	}, [props.event]);
	
	function applyVisualChanges() {
		setRefresh(!refresh);
	}

	const disableOtherDates = function (input) {
		const exists = availableLessonDates?.find((item) => {
			const momentItem = moment(item.dateTime);
			return isSameDate(momentItem, input)
		});

		return input.day() === 0 || !exists;
	}

	function isSameDate(date1, date2) {
		return date1.date() === date2.date() && date1.month() === date2.month() && date1.year() === date2.year();
	}

	const closeModal = () => {
		props.closeHandler();
	};

	const updatePair = (e, newVal) => {
		setEvent((prevEvent) => ({ ...prevEvent, pairNumber: newVal.props.value }));
	};

	const updateTheme = (e) => {
		setEvent((prevEvent) => ({ ...prevEvent, themePlanId: e.target.value }));
	};

	const updateDate = (e) => {
		const newEvent = { ...event };
		newEvent.lessonDate = e;
		setEvent(newEvent);
		
		findAvailablePairsByDate(e);
	};
	
	const findAvailablePairsByDate = (e) => {
		const dates = availableLessonDates.filter((item) => {
			const left = moment(item.dateTime).toDate();
			const right = e.toDate();
			
			return left.getDate() === right.getDate()
				&& left.getMonth() === right.getMonth()
				&& left.getFullYear() === right.getFullYear();
		});
		
		const temp = [];
		dates.forEach((item) => {
			if (temp.find((x) => x === item.pairNumber) === undefined) {
				temp.push(item.pairNumber);
			}
		});
		
		setAvailablePairs(temp);
	};

	const save = () => {
		props.saveHandler(event);
	};

	const deleteHandler = () => {
		props.deleteHandler(event);
	};

	return (
		<div
			className={props.open ? "modal-wrapper open" : "modal-wrapper"}
			id="event"
		>
			<div className="modal">
				<div className="modal-content">
					<div className="modal-header" style={{"display": "flex", "justifyContent": "space-between"}}>
						<div className="name">Редактирование занятия {isAdmin ? props?.event?.lessonId : ''}</div>
						<IconButton onClick={closeModal}>
							<CloseRounded />
						</IconButton>
					</div>
					<Grid container columnSpacing={2} rowSpacing={3}>
						<Grid item md={12}>
							<TextField
								onChange={updateTheme}
								value={event?.themePlanId}
								sx={{ width: "100%" }}
								select
								variant="standard"
								label="Тема занятия"
							>
								{props.themes?.map((item) => {
									return <MenuItem key={item.themePlanId} value={item.themePlanId}>{item.theme}</MenuItem>
								})}
							</TextField>
						</Grid>
						<Grid item md={8}>
							<LocalizationProvider
								dateAdapter={AdapterDayjs}
								adapterLocale="ru"
							>
								<DatePicker
									value={dayjs(new Date(event.lessonDate))}
									format="D MMMM YYYY г."
									variant="standard"
									label="Дата занятия"
									disableFuture
									shouldDisableDate={disableOtherDates}
									sx={{ width: "100%" }}
									onChange={updateDate}
									slotProps={{
										textField: {
											variant: "standard",
										},
									}}
								/>
							</LocalizationProvider>
						</Grid>
						<Grid item md={4}>
							<FormControl
								variant="standard"
								sx={{ width: "100%" }}
							>
								<InputLabel>Пара</InputLabel>
								<Select
									value={event.pairNumber}
									onChange={updatePair}
								>
									{availablePairs.sort().map((item) => {
										return <MenuItem key={item} value={item}>{item} пара</MenuItem>
									})}
								</Select>
							</FormControl>
						</Grid>
					</Grid>
				</div>
				<div className="modal-footer">
					<Button variant="text"
							color={'error'}
							disabled={props.isDeleting}
							startIcon={props.isDeleting ? <CircularProgress size={15} /> : <></>}
							onClick={deleteHandler}>
						Удалить
					</Button>
					<span />
					
					<Button variant="text"
							disabled={props.isSaving}
							startIcon={props.isSaving ? <CircularProgress size={15} /> : <></>}
							onClick={save}>
						Сохранить
					</Button>
				</div>
			</div>
		</div>
	);
}

export default DateModal;
